// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aH_h","option":"styles_option__OgoNc","selected":"styles_selected__2ty-L"};